import { styled } from '@mui/material/styles';
import {
  Box,
  Collapse,
  Table,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import type { RowWrapperProps } from './components/CoparticipationMainRow/types';

const RowWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== 'open',
})<RowWrapperProps>(({ open }) => ({
  border: `1px solid ${
    open ? NEW_COLORS.SEMANTICS.WARNING[400] : NEW_COLORS.GRAYSCALE[200]
  }`,
  borderRadius: 4,
  overflow: 'hidden',
  marginBottom: 8,
}));

const StyledTableHead = styled(TableHead)(() => ({
  '& th': {
    borderBottom: 'unset',
  },
}));

const StyledTableRow = styled(TableRow, {
  shouldForwardProp: prop => prop !== 'open',
})<RowWrapperProps>(() => ({
  position: 'relative',
  '& th': {
    borderBottom: 'unset',
  },
}));

const StyledTable = styled(Table)(() => ({
  borderCollapse: 'separate',
  borderSpacing: '0 6px',
  marginTop: '-8px',
}));

const StyledCollapse = styled(Collapse)(({ theme }) => ({
  position: 'relative',
  marginTop: '-8px',
  borderBottomLeftRadius: 8,
  borderBottomRightRadius: 8,
  borderLeft: `1px solid ${NEW_COLORS.SEMANTICS.WARNING[400]}`,
  borderRight: `1px solid ${NEW_COLORS.SEMANTICS.WARNING[400]}`,
  [theme.breakpoints.down('md')]: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderLeft: 'none',
    borderRight: 'none',
  },
}));

const StyledTableCellCollapse = styled(TableCell, {
  shouldForwardProp: prop => prop !== 'open',
})<RowWrapperProps>(({ open, theme }) => ({
  padding: 0,
  border: open ? `1px solid ${NEW_COLORS.SEMANTICS.WARNING[400]}` : 'none',
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  borderBottomLeftRadius: 8,
  borderBottomRightRadius: 8,

  [theme.breakpoints.down('md')]: {
    border: 'none',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
}));

export {
  StyledTableCellCollapse,
  StyledCollapse,
  StyledTable,
  StyledTableRow,
  StyledTableHead,
  RowWrapper,
};
